// @ts-nocheck
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from './../sharedcomponents/ConfirmationWindow'; 
import * as PopupConfirmWindow from './../sharedcomponents/PopupConfirmWindow';
import OrbcommLogo11 from '../../images/ORBCOMMLOGOR.svg';
import { RCUtils } from './../../RCUtils';
import $ from 'jquery';
import logo1 from '../../images/newTitleOrb.png';
import logo2 from '../../images/login_bg1.jpg';
var Config: any = require('../../Config.json');

interface ForgotState {
    UserName: string,
    Message: string
}

export default class ForgotPassword extends React.Component<RouteComponentProps<{}>, ForgotState> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        this.state = { UserName: '', Message: '' };
    }

    UsernameChange(event: React.FormEvent<HTMLInputElement>) {
        var userid = this.state.UserName;
        var Value: string = event.currentTarget.value;
        userid = Value;
        this.setState({
            UserName: userid
        });
    }

    ValidateNChangePassword() {
        if ((this.state.UserName == null || this.state.UserName == "")) {
            PopupWindow.showErrorMessage("Alert", "Please enter Username");//Email
            return;
        }
        else {
            $('#globalLoader').show();
            var uName = this.state.UserName;
            this.myRequest = new Request(Config.ApiBaseUrl + '/api/AuthUser/ResetPassword?email=' + uName);

            //fetch(this.myRequest)
            //    .then((res) => res.json())
            //    .then((data) => {
              RCUtils.fetchRetry(this.myRequest)
                   .then(RCUtils.handleResponse)
                   .then(response => response.json() as Promise<any>)
                   .then(data => {
                    $('#globalLoader').hide();
                    this.setState({ Message: data });
                    if (data == "Success") {
                        var confirmationMessage = "Password has been successfully reset. Temporary password will be sent to the user email address.";
                        PopupConfirmWindow.PopupConfirmWindow.showConfirmBox(confirmationMessage, this.redirectToLogin.bind(this));
                        return;
                    }
                    else if (data == "NotExist") {
                        PopupWindow.showErrorMessage("Error", "Invalid Username, please contact your fleet administrator / Orbcomm Customer Care.");
                        return;
                    }
                    else if (data == "Error") {
                        PopupWindow.showErrorMessage("Error", "Error occurred while reset password.");
                        return;
                    }
                    else if (data == "Inactive") {
                        PopupWindow.showErrorMessage("Error", "you are not authorized to use Maritime platform application.");
                        return;
                    }
                    else {
                        PopupWindow.showErrorMessage("Error", data);
                        return;
                    }
                   }).catch(err => {
                       $('#globalLoader').hide();
                       PopupWindow.showErrorMessage("Error", "Error Occurred. Please try again.")
                   });
        }
    }

    redirectToLogin() {
        PopupConfirmWindow.PopupConfirmWindow.close();
        this.props.history.push('/'); 
    }

    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    RedirectToLogin() {
        RCNGWindow.ConfirmWindow.close();
        this.props.history.push('/');    
    }

    CancelRequest() {
        this.props.history.push('/');
    }

    public render() {
        var divStyle = {
            backgroundImage: `url(${logo2})`
        }

        return <div className='login-bg img-responsive' style={divStyle}> 
            <div id='divMsgboxDynamicContent'></div>
            <div className='login-form'>
                <div>
                    <div className='login-page-line'></div>
                    <div className='login-logo-maritime'>
                        <img src={OrbcommLogo11} alt="Maritime platform" className='login-page-logo' />
                        <span className='login-maritime'> MARITIME </span>
                    </div>
                </div>
                <form>
                    <div>
                        <label>To reset your password, enter your username.</label>
                    </div>
                    <div className='mt-2'>
                        <input type='text' name='UserName' className='form-control email-control' id='txtEmail' value={this.state.UserName} onChange={e => this.UsernameChange(e)} placeholder='Username' />
                    </div>
                    <div className='modal-footer mt-3'>
                        <button type='button' className='btn btn-secondary' onClick={this.CancelRequest.bind(this)}>Cancel</button>
                        <button type='button' className='btn btn-primary' onClick={this.ValidateNChangePassword.bind(this)}>Save</button>
                       
                    </div>
                </form>
            </div>
        </div>;
    }
}
